import type { Operation } from "../../fast-json-patch/core";
import { type Tuple } from "../Tuple";

export type Change<TOut> =
	| {
			type: "INSERT";
			recordId: string;
			record: Tuple<TOut>;
	  }
	| {
			type: "UPDATE";
			recordId: string;
			change: Operation;
			output: Tuple<TOut>;
	  }
	| {
			type: "DELETE";
			recordId: string;
	  };

export const insert = <T>(record: Tuple<T>) =>
	({ type: "INSERT", recordId: record.id, record }) satisfies Change<T>;

export const update = <T>(change: Operation, output: Tuple<T>) =>
	({ type: "UPDATE", recordId: output.id, change, output }) satisfies Change<T>;

export const deleteChange = <T>(recordId: string) =>
	({ type: "DELETE", recordId }) satisfies Change<T>;
